var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLink)?_c('span',[_vm._v(_vm._s(_vm.value))]):_c('span',[_c('a',{staticClass:"g-link",attrs:{"href":_vm.value}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }